import styled from 'styled-components';
import { Box, Input, Button, Flex, Text } from '@pancakeswap/uikit';

export const Container = styled(Box)`
  max-width: 800px;
  margin: auto;
  padding: 24px;
  background: linear-gradient(145deg, #000, #000);
  border-radius: 16px;
  box-shadow: 0 0 12px rgba(0, 255, 255, 0.1);
`;

export const StyledInput = styled(Input)`
  background-color: #000;
  color: #fff;
  padding: 16px;
  border-radius: 10px;
  border: 1px solid #1fc7d4;
  margin-top: 12px;

  ::placeholder {
    color: #999;
  }
`;
export const NetworkIcon = styled.img`
  height: 28px;
  width: 28px;
  margin: 0 12px;
`;
export const StyledButton2 = styled(Button)`
  margin-top: 16px;
  width: 100%;
      background: transparent;
      border: 2px solid #627EEA;
  color: white;
  font-weight: bold;
  border-radius: 10px;
  transition: all 0.3s ease;
  &:hover,
  &:active {
      background: #627EEA;
  color: white;
  }
  &:disabled {
      background: #627EEA;
    color: #fff;
  }
`;

export const StyledButton = styled(Button)`
  margin-top: 16px;
  width: 100%;
         background: #F0B90B;
  color: black;
  font-weight: bold;
  border-radius: 10px;
  transition: all 0.3s ease;

  &:hover,
  &:active {
     background: transparent;
      border: 2px solid #F0B90B;
  color: white;
  }

  &:disabled {
     background: transparent;
      border: 2px solid #F0B90B;    color: #fff;
  }
`;


export const Header = styled(Flex)`
  justify-content: center;
  margin-bottom: 24px;
`;

export const Title = styled(Text)`
  font-size: 24px;
  font-weight: 600;
  color: #ffffff;
`;

